// The on-screen keyboard (iPhone): the phone frame is fixed to the whole screen, and iOS does not shrink it when the
// keyboard opens, so the assistant's composer, the activity's dock and a sheet's inputs sat under the keyboard. The
// visual viewport does shrink: its height, and how far iOS panned it, give the keyboard's height, kept in --ph-kb on
// the root for the frame, the dock and the sheets to stand on.
import { useEffect } from 'react';

/** How much of the layout viewport the keyboard covers, in px (0 with no keyboard, or without visualViewport). */
export function keyboardHeight(innerHeight: number, vv: { height: number; offsetTop: number } | null | undefined): number {
  if (!vv) return 0;
  const kb = Math.round(innerHeight - vv.height - vv.offsetTop);
  // Below 80px it is the browser's own bars changing size, not a keyboard.
  return kb > 80 ? kb : 0;
}

export function useKeyboardInset() {
  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return;
    const root = document.documentElement;
    const on = () => root.style.setProperty('--ph-kb', `${keyboardHeight(window.innerHeight, vv)}px`);
    on();
    vv.addEventListener('resize', on);
    vv.addEventListener('scroll', on);
    return () => { vv.removeEventListener('resize', on); vv.removeEventListener('scroll', on); root.style.removeProperty('--ph-kb'); };
  }, []);
}
